import NarratorsCommentaryResultItem from './NarratorsCommentaryResultItem';

export default NarratorsCommentaryResultItem;
